import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/contactUs/ico-kf.png'
import _imports_1 from '../assets/img/contactUs/ico-user.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-6e30a2e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-6e30a2e1><div class=\"textbox\" data-v-6e30a2e1><div class=\"banner-text1\" data-v-6e30a2e1>联系我们</div><div class=\"banner-text2\" data-v-6e30a2e1>共性中立 兼容互通 全国互认</div></div></div><div class=\"box1\" data-v-6e30a2e1><div class=\"title\" data-v-6e30a2e1></div><div class=\"content\" data-v-6e30a2e1><div class=\"infocard\" data-v-6e30a2e1><div class=\"top\" data-v-6e30a2e1><div class=\"top-text\" data-v-6e30a2e1>客服咨询</div></div><div class=\"infobox\" data-v-6e30a2e1><div data-v-6e30a2e1><div style=\"display:flex;justify-content:space-between;\" data-v-6e30a2e1><div class=\"row\" data-v-6e30a2e1><img src=\"" + _imports_0 + "\" alt=\"\" class=\"ico1\" data-v-6e30a2e1><span class=\"infotext1\" data-v-6e30a2e1>  电话热线:</span><span class=\"infotext2\" data-v-6e30a2e1> 400 666 6011</span></div><div class=\"infotext2\" style=\"float:right;\" data-v-6e30a2e1>（周一 至 周日 8：30 - 21：00）</div></div></div></div></div><div class=\"infocard\" data-v-6e30a2e1><div class=\"top2\" data-v-6e30a2e1><div class=\"top-text\" data-v-6e30a2e1>技术支持</div></div><div class=\"infobox\" data-v-6e30a2e1><div data-v-6e30a2e1><div style=\"display:flex;justify-content:space-between;\" data-v-6e30a2e1><div class=\"row\" data-v-6e30a2e1><img src=\"" + _imports_1 + "\" alt=\"\" class=\"ico1\" data-v-6e30a2e1><span class=\"infotext1\" data-v-6e30a2e1>  许经理：</span><span class=\"infotext3\" data-v-6e30a2e1> 1590 126 5905</span></div></div></div></div></div></div></div>", 2)
const _hoisted_3 = [
  _hoisted_1
]

import { reactive, toRefs, ref,onMounted } from 'vue'




export default /*#__PURE__*/_defineComponent({
  __name: 'contactUs',
  setup(__props) {

onMounted(()=>{
    window._czc.push(['_trackEvent', '联系我们', '联系我们', '查看客服与技术咨询电话' ])
})






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_3))
}
}

})